import React, {Component} from 'react';
import GlobalPortfolioReduce from "../components/tables/globalPortfolioReduce";
import GlobalPortfolioReduceGraph from "../charts/globalPortfolioReduceGraph"

import * as dataService from "../service/data-info-chart/requestsUtil"
import {PERFORMANCE_ANALYSIS, GLOBAL_PORTFOLIO_REDUCE, WHITOUT_INFORMATION} from "../utils/constants";
import * as cbu from "../utils/checkBusinessUnit";

var Loader = require('react-loader');

class PortfolioAccountsClassificationComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {data: [], loaded: false}
  }

  componentDidMount() {
    dataService.getFetch(PERFORMANCE_ANALYSIS + cbu.checkBusinessUnit(this.props.bu) + GLOBAL_PORTFOLIO_REDUCE)
      .then((json) => {
        this.setState({data: json, loaded: true});
      });
  }

  render() {

    if (this.state.data.length > 0) {
      return (
        <Loader top={'90%'} loaded={this.state.loaded}>
          <GlobalPortfolioReduce striped={true} data={this.state.data}/>
          <GlobalPortfolioReduceGraph data={this.state.data}/>
        </Loader>
      );
    } else {
      return (<Loader loaded={this.state.loaded} top="50%"><h2 className="without-avilable-information">{WHITOUT_INFORMATION}</h2></Loader>);
    }


  }
}

export default PortfolioAccountsClassificationComponent;




// WEBPACK FOOTER //
// ./src/components/globalDecreasePortfolioComponent.js